import { fetcher } from "utils";

import { MemberSerialized } from "typings";

export const get__members = (): Promise<MemberSerialized> => fetcher.get(`/members`);
